
const TextoPadraoBlog = ({ texto }) => {
    return (
        <div
            style={{
                maxWidth: "800px",
                margin: "0 auto",
                padding: "10px",
                fontSize: "1.1rem",
                lineHeight: 1.8,
                color: "#333",
            }}
        >
            {texto.map((paragrafo, index) => (
                <>
                    <p key={index} style={{marginBottom: "10px", textAlign: "justify"}}>{paragrafo}</p>
                </>
            ))}
        </div>
    );
}

export default TextoPadraoBlog;